
  import { defineComponent } from 'vue';
  import { AxiosError } from 'axios';

  import text from '@/common/mixins/text';
  import Tooltip from '@/common/ui/Tooltip.vue';

  import EChartsColumnAndLine from '@/components/ChartComponents/apacheEcharts/EChartsColumnAndLine.vue';
  import ChartContainer from '@/components/ChartComponents/ChartContainer.vue';
  import Loader from '@/components/Loader.vue';

  import Api from '../api';
  import { TBudgetChartItem } from '../types/budget';

  export default defineComponent({
    name: 'BudgetChart',
    components: { ChartContainer, EChartsColumnAndLine, Tooltip, Loader },
    mixins: [text],
    props: {
      countryId: {
        type: String,
        required: true,
      },
      title: {
        type: String,
        default: '',
      },
      titleTooltipContent: {
        type: String,
        default: '',
      },
    },
    data(): {
      isLoading: boolean;
      data: TBudgetChartItem[];
    } {
      return {
        isLoading: false,
        data: [],
      };
    },
    created() {
      this.loadChart();
    },
    computed: {
      getXData() {
        return this.data.map((item) => item.year);
      },
      getColumnYData() {
        return this.data.map((item) => this.toTwoDecimals(item.governmentDebt));
      },
      getLineYData() {
        return this.data.map((item) => this.toTwoDecimals(item.currentCountryValue));
      },
    },
    methods: {
      toTwoDecimals(value: number | null | undefined) {
        if (value == null) return null;
        return Number(this.formatNumber(value, 2, '', '.'));
      },
      formatYLabel(value: number) {
        return this.formatNumber(value, 2, ',');
      },
      async loadChart() {
        this.isLoading = true;

        try {
          const response = await Api.getBudgetPolicyChart(this.countryId);
          this.data = response.data;
        } catch (error: unknown) {
          console.error((error as AxiosError).response?.data);
        } finally {
          this.isLoading = false;
        }
      },
    },
    watch: {
      countryId: function () {
        this.loadChart();
      },
    },
  });
